import React, {Component} from 'react';
import {Row, Col, Button, Container} from "reactstrap";
import {inject, observer} from "mobx-react";
import Card from "../../../comum/components/Card";
import {FecharFiltro, Filtro, IconeCarregar} from "../../../comum/components/Icones";
import FiltrosCabotagemStore from "../stores/FiltrosCabotagemStore";
import InputFiltro from "../../../comum/components/InputFiltro";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import FormOnlyPositiveNumberSimples from '../../../comum/components/FormNumberSimples';
import lscache from 'lscache';

@inject("store")
@observer
export default class FiltrosCabotagem extends Component {
    constructor(props) {
        super(props);

        this.controllerCabotagem = this.props.controller;
        this.controller = new FiltrosCabotagemStore();

        this.state = { maisFiltros: false, filtrado: false };
    };

    componentDidMount () {
        const pesquisa = lscache.get('acompProcesso-pesquisa-doc');
        lscache.set('acompProcesso-pesquisa-voltar', 5);
        if (pesquisa) 
            this.handleFiltrar();        
    }

    handleFiltrar() {
        this.setState(state => ({filtrado: true}));
        
        const pesquisa = lscache.get('acompProcesso-pesquisa-doc');        
        if (pesquisa) {
            const documentoCTE = lscache.get('acompProcesso-cabotagem-doc');
            _.set(this.controller.filtros, "cte", documentoCTE ? documentoCTE : null);
        };
        
        _.set(this.controller.filtros, "operacao", this.controller.filtroNavio ? this.controller.filtroNavio.value : null);
        _.set(this.controller.filtros, "situacao", this.controller.filtroSituacao ? this.controller.filtroSituacao.value : null);
        this.controllerCabotagem.listar(this.controller.filtros);
    };

    filtros = () => {
        if (!this.state.maisFiltros) {
            return this.filtrosBasicos();
        } else {
            return this.filtrosCompletos();
        }
    };

    filtrosBasicos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
                <FormSelectSimples titulo="Navio" xl={xl} lg={lg} md={md} sm={12} xs={12}
                    itens={ this.controllerCabotagem.naviosFiltros }
                    dado={ this.controller.filtroNavio }
                    bloqueado={!this.controllerCabotagem.naviosFiltros}
                    onChange={ (event) => this.controller.onChangeFiltroNavios(event) } />
                { this.controllerCabotagem.loadingNavios && <IconeCarregar tamanho="2x"/> }
                <InputFiltro titulo="CTe" xl={xl} lg={lg} md={md} sm={12} xs={12} value={lscache.get('acompProcesso-pesquisa-doc') ? lscache.get('acompProcesso-cabotagem-doc') : ""}
                         onEnter={() => this.handleFiltrar()}
                         onChange = { (event) => this.controller.onChangeFiltro("cte", event) } />
                <Col className="col-botoes pl-1" xl={xl} lg={lg} md={md} sm={12} xs={12}>
                    <Button className="btn-filtros" onClick={ () => this.mudaFiltros() } outline>
                        <Filtro color="#93A0AD" className="mr-2" width="15" height="15"/>
                        Mais filtros
                    </Button>
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={ () => { lscache.remove('acompProcesso-pesquisa-doc');  this.handleFiltrar()} }>Filtrar</Button>
                </Col>
            </React.Fragment>
    };

    filtrosCompletos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
                {/*<Col>*/}
                    {/*<Row className={"linhaFiltros"}>*/}
                <FormSelectSimples titulo="Navio" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        itens={ this.controllerCabotagem.naviosFiltros }
                        dado={ this.controller.filtroNavio }
                        bloqueado={!this.controllerCabotagem.naviosFiltros}
                        onChange={ (event) => this.controller.onChangeFiltroNavios(event) } />
                { this.controllerCabotagem.loadingNavios && <IconeCarregar tamanho="2x" cor="#001C43" /> }
                <InputFiltro titulo="CTe" xl={xl} lg={lg} md={md} sm={12} xs={12} value={lscache.get('acompProcesso-pesquisa-doc') ? lscache.get('acompProcesso-cabotagem-doc') : ""}
                         onEnter={() => this.handleFiltrar()}
                         onChange = { (event) => this.controller.onChangeFiltro("cte", event) } />
                <InputFiltro titulo="Cód Container" xl={xl} lg={lg} md={md} sm={12} xs={12}
                         onEnter={() => this.handleFiltrar()}
                         onChange = { (event) => this.controller.onChangeFiltro("cntr", event) } />
                <FormOnlyPositiveNumberSimples titulo="Chave CTe" xl={xl} lg={lg} md={md} sm={12} xs={12}
                         onEnter={() => this.handleFiltrar()}
                         onChange = { (event) => this.controller.onChangeFiltro("chave", event) } />
                <FormSelectSimples titulo="Situação" xl={xl} lg={lg} md={md} sm={12} xs={12}
                        itens={ this.controller.situacoesFiltros }
                        dado={ this.controller.filtroSituacao }
                        bloqueado={!this.controller.situacoesFiltros}
                        onChange={ (event) => this.controller.onChangeFiltroSituacao(event) } />
                <Col className="col-botoes" xl={xl} md={md} sm={12} xs={12}>
                    <Button className="btn-filtros" onClick={ () => this.mudaFiltros() } outline>
                        <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/>
                        Menos filtros
                    </Button>
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={ () => { lscache.remove('acompProcesso-pesquisa-doc');  this.handleFiltrar()} }>Filtrar</Button>
                </Col>
            </React.Fragment>
    };

    mudaFiltros = () => {
        this.setState({maisFiltros: !this.state.maisFiltros});
    };

    inserindoNovas = () => {
        return this.controllerCabotagem.novasCabotagens.length > 0;
    };

    render() {
        return(
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0 ${!this.inserindoNovas() ? "" : "escondido"}`}>
                    <Row className="pb-0">
                        { this.filtros() }
                    </Row>
                </Card>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/components/FIltrosCabotagem.js